module.exports = __webpack_public_path__ + "img/Sicepat.e9367610.svg";